import React, { Component } from 'react';
import { StyledHeader } from '../styles';
import ParnerLogo from '../../Content/Shared/PartnerLogo';

class ForebyggHeader extends Component {
  render() {
    return (
      <StyledHeader background="#E5F4F5" boxShadow="none">
        <ParnerLogo
          getTranslation={(messageCode) => this.props.getTranslation(messageCode)}
          isHeaderLogo={true}
        />
      </StyledHeader>
    );
  }
}

export default ForebyggHeader;
